import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'mc-notification-icon',
  template: `<span *ngIf="text !== null" class="circle update-display">
                {{text}}
            </span>
  `,
  styleUrls: ['notification-icon.component.scss']
})
export class NotificationIconComponent implements OnInit {

  @Input() text = null;

  constructor() { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/shared/ui/notification-icon/notification-icon.component.ts